export type Tone = "ok" | "warn" | "neg" | "neutral";

export const TONE: Record<Tone, string> = {
  ok: "bg-green-50 border-green-200 text-green-700",
  warn: "bg-amber-50 border-amber-200 text-amber-700",
  neg: "bg-red-50 border-red-200 text-red-700",
  neutral: "bg-gray-50 border-gray-200 text-gray-500",
};

// Determinístico (não depende do ICU do runtime — Node pequeno não agrupa
// milhares em pt-PT): agrupa com espaço regular e usa vírgula decimal.
function formatEur(value: number): string {
  const [int, frac] = value.toFixed(2).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${grouped},${frac} €`;
}

function formatPct(fraction: number): string {
  return `${(fraction * 100).toFixed(1).replace(".", ",")}%`;
}

export const eur = { format: formatEur };
export const pct = { format: formatPct };

// margem <0 negativa; 0–5% atenção; >=5% ok; ausente = neutra
export function marginTone(pctFraction: number | null | undefined): Tone {
  if (pctFraction == null) return "neutral";
  if (pctFraction < 0) return "neg";
  if (pctFraction < 0.05) return "warn";
  return "ok";
}
